import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export default function MediaCard() {
	return (
		<Card>
			<CardContent>
				<Typography gutterBottom variant="h4" component="div">
					Important
				</Typography>
				<Typography variant="body1" gutterBottom>
					This module its only to upload files with specific nomenclature such:
				</Typography>
				<Typography variant="body1" gutterBottom>
					- Nemesis_Antennas (.csv)
				</Typography>
				<Typography variant="body1" gutterBottom>
					- EE_3G_RET_Licences (.csv)
				</Typography>
				<Typography variant="body1" gutterBottom>
					- EE LTE RET Data (.xlsx)
				</Typography>
				<Typography variant="body1" gutterBottom>
					- Combined RET Report EE (.xlsx)
				</Typography>
				<Typography variant="body1" gutterBottom>
					- Combined MHA Report EE (.xlsx)
				</Typography>
			</CardContent>
		</Card>
	);
}
